@use 'styles/mixins/_a11y.scss' as a11y;
@use 'styles/mixins/_fonts.scss' as fonts;

.characters-count {
    @include fonts.body-accent-xs;

    color: var(--color-text-subtle);
}

.visually-hidden {
    @include a11y.visually-hidden;
}